import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Rect } from "react-native-svg";

export const IconStudioDisplay1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStudioDisplay1"><Rect x="9" y="17" width="6" height="4" fill="currentColor"/><Rect x="2" y="3" width="20" height="13" fill="currentColor"/></CentralIconBase>;
});

export default IconStudioDisplay1;
